<h2 mat-dialog-title class="flex items-center mt-3">
  {{ message('settingsHeader') }}
  <span class="ml-auto material-icons cursor-pointer hover:opacity-80" (click)="close()">close</span>
</h2>
<mat-dialog-content class="flex flex-col">
  <mat-form-field appearance="outline" class="mt-2 max-w-60">
    <mat-label>{{ message('resourceCostMultiplier') }}</mat-label>
    <input #craftResourceInput matInput type="number" step=".1" min=".1" [value]="craftResourceModifier()"
           (focusout)="changeCraftResourceModifier(craftResourceInput.value)">
  </mat-form-field>
  <mat-slide-toggle
    class="mt-2"
    [checked]="expensiveEndgameRecipes()"
    (change)="toggleExpensiveEndgameRecipes()">
    {{ message('endGameCraftOption') }}
  </mat-slide-toggle>
</mat-dialog-content>
